import React from 'react';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import Footer from '@/components/Footer';

const FONT = '"Inter", system-ui, -apple-system, sans-serif';

const TermsPage: React.FC = () => (
  <Box sx={{ bgcolor: 'white', fontFamily: FONT }}>
    {/* ─── Hero ───────────────────────────────────────────────── */}
    <Box sx={{ py: { xs: 10, md: 14 }, position: 'relative', overflow: 'hidden' }}>
      <Box sx={{
        position: 'absolute', inset: 0, zIndex: 0,
        background: `
          radial-gradient(ellipse 80% 60% at 50% 30%, rgba(16,185,129,0.06) 0%, transparent 60%),
          linear-gradient(to bottom, #fafbfc 0%, white 100%)
        `,
      }} />

      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontFamily: FONT, fontWeight: 800,
            fontSize: { xs: '2.2rem', md: '3rem' },
            lineHeight: 1.1, letterSpacing: '-0.03em',
            color: '#0f172a', mb: 2,
          }}
        >
          Terms of Service
        </Typography>
        <Typography sx={{
          fontFamily: FONT, fontSize: '1rem',
          color: 'text.secondary',
        }}>
          Last updated: April 2026
        </Typography>
      </Container>
    </Box>

    {/* ─── Content ────────────────────────────────────────────── */}
    <Container maxWidth="md" sx={{ pb: { xs: 10, md: 14 } }}>
      <Box sx={{
        '& h2': { fontFamily: FONT, fontWeight: 700, fontSize: '1.4rem', color: '#0f172a', mt: 5, mb: 2 },
        '& p': { fontFamily: FONT, fontSize: '1rem', color: 'text.secondary', lineHeight: 1.8, mb: 2 },
      }}>
        <Typography component="h2">Agreement to Terms</Typography>
        <Typography component="p">
          By accessing or using Player Central, you agree to be bound by these Terms of Service. If you do not agree
          to these terms, please do not use the service.
        </Typography>

        <Typography component="h2">Use of the Service</Typography>
        <Typography component="p">
          Player Central is a scheduling and analytics tool for youth sports families. You may use the service for
          personal, non-commercial purposes in accordance with these terms. You are responsible for maintaining the
          security of your account credentials.
        </Typography>

        <Typography component="h2">Your Content</Typography>
        <Typography component="p">
          You retain ownership of any content you create or upload to the service. By using the service, you grant us
          a limited license to store and display your content as necessary to operate the product.
        </Typography>

        <Typography component="h2">Availability</Typography>
        <Typography component="p">
          We strive to keep the service available and reliable, but we do not guarantee uninterrupted access. We may
          perform maintenance or updates that temporarily affect availability.
        </Typography>

        <Typography component="h2">Limitation of Liability</Typography>
        <Typography component="p">
          Player Central is provided "as is" without warranties of any kind. We are not liable for any
          indirect, incidental, or consequential damages arising from your use of the service.
        </Typography>

        <Typography component="h2">Changes to Terms</Typography>
        <Typography component="p">
          We may update these terms from time to time. Continued use of the service after changes constitutes
          acceptance of the revised terms.
        </Typography>

        <Typography component="h2">Contact</Typography>
        <Typography component="p">
          If you have any questions about these Terms of Service, please contact us at eleventhtriangular@gmail.com.
        </Typography>
      </Box>
    </Container>

    <Footer />
  </Box>
);

export default TermsPage;
